import React, { useEffect, useState } from 'react';
import { Card, Form, Button, Upload, Space, Alert } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getBanner, updateBanner } from '../../store/slices/settingSlice';

const ManageBanner = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');
    const [homeFileList, setHomeFileList] = useState([]);
    const [categoryFileList, setCategoryFileList] = useState([]);

    const { banners } = useSelector((state) => state?.settings)
    useEffect(() => {
        dispatch(getBanner())
    }, [dispatch])

    // const homeBanner = banners?.data?.find(b => b.type === "home");
    // const categoryBanner = banners?.data?.find(b => b.type === "category");
    useEffect(() => {
        if (banners?.data?.length) {
            const home = banners?.data?.find(b => b.type === "home");
            const category = banners?.data?.find(b => b.type === "category");
            console.log(home)

            if (home) {
                setHomeFileList([
                    {
                        uid: "-1",
                        name: "home-banner.jpg",
                        status: "done",
                        url: home.image,
                    },
                ]);
            }

            if (category) {
                setCategoryFileList([
                    {
                        uid: "-2",
                        name: "category-banner.jpg",
                        status: "done",
                        url: category.image,
                    },
                ]);
            }
        }
    }, [banners]);

    const onFinish = async (values) => {
        setLoading(true);

        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            const formData = new FormData();

            if (values.homeBanner) {
                formData.append(
                    'homeBanner',
                    values.homeBanner?.file
                );
            }

            if (values.categoryBanner) {
                formData.append(
                    'categoryBanner',
                    // values.categoryBanner[0].originFileObj
                    values.categoryBanner?.file
                );
            }

            const result = await dispatch(updateBanner(formData));

            if (updateBanner.fulfilled.match(result)) {
                setAlertMessage('Banners updated successfully');
                setAlertType('success');
            } else {
                setAlertMessage(result?.payload?.error || 'Failed to update banners');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Something went wrong');
            setAlertType('error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Banner Management</h1>

            {alertMessage && (
            <Alert
                message={alertMessage}
                type={alertType}
                showIcon
                closable
                style={{ marginBottom: 20 }}
            />
            )}

            <Form form={form} layout="vertical" onFinish={onFinish}>
            <Card
                title="Home Banner"
                style={{ marginBottom: 20 }}
            >
                <Form.Item
                label="Upload Home Banner"
                name="homeBanner"
                // valuePropName="fileList"
                // getValueFromEvent={(e) =>
                //     Array.isArray(e) ? e : e?.fileList
                // }
                >
                <Upload
                    beforeUpload={() => false}
                    maxCount={1}
                    listType="picture"
                    fileList={homeFileList}
                    onChange={({ fileList }) => setHomeFileList(fileList)}
                >
                    <Button icon={<UploadOutlined />}>
                    Select Home Banner
                    </Button>
                </Upload>
                </Form.Item>
            </Card>

            <Card
                title="Category Banner"
                style={{ marginBottom: 20 }}
            >
                <Form.Item
                label="Upload Category Banner"
                name="categoryBanner"
                // valuePropName="fileList"
                // getValueFromEvent={(e) =>
                //     Array.isArray(e) ? e : e?.fileList
                // }
                >
                <Upload
                    beforeUpload={() => false}
                    maxCount={1}
                    listType="picture"
                    fileList={categoryFileList}
                    onChange={({ fileList }) => setCategoryFileList(fileList)}
                >
                    <Button icon={<UploadOutlined />}>
                    Select Category Banner
                    </Button>
                </Upload>
                </Form.Item>
            </Card>

            <Form.Item>
                <Space>
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                >
                    Save Changes
                </Button>
                </Space>
            </Form.Item>
            </Form>
        </div>
    );
};

export default ManageBanner;